import { Cell, CellProps } from 'react-aria-components'

import { joinStyles } from '@/utils/app/theme'

import * as styles from './index.css'

type TableFooterCellProperties = CellProps & {
    className?: string
}

export const TableFooterCell = ({
    className,
    ...properties
}: Readonly<TableFooterCellProperties>) => {
    return (
        <Cell
            className={joinStyles(styles.root, className)}
            {...properties}
        />
    )
}
